import { render, staticRenderFns } from "./lawTelephone.vue?vue&type=template&id=210ef2b8&scoped=true&"
import script from "./lawTelephone.vue?vue&type=script&lang=js&"
export * from "./lawTelephone.vue?vue&type=script&lang=js&"
import style0 from "./lawTelephone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lawTelephone.vue?vue&type=style&index=1&id=210ef2b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ef2b8",
  null
  
)

export default component.exports